import { render, staticRenderFns } from "./SalesConfiguration.vue?vue&type=template&id=38b76098&"
import script from "./SalesConfiguration.vue?vue&type=script&lang=js&"
export * from "./SalesConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports